import React, {useEffect, useContext} from 'react';
import {Link} from 'react-router-dom';
import {Card, Col, Row} from 'react-bootstrap';

import Section from 'components/common/Section';

import {faHome} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import AppContext from 'config/app-context';

const Error403 = () => {
	const {config, setConfig} = useContext(AppContext);

	useEffect(() => {
		// Solo actualiza si 'isFullscreen' cambia de estado
		if (config.isFullscreen !== true) {
		  setConfig('isFullscreen', true);
		}
	
		return () => {
		  if (config.isFullscreen !== false) {
			setConfig('isFullscreen', false);
		  }
		};
	}, [setConfig, config.isFullscreen]); // Dependencias ajustadas para evitar bucles

	return (
		<Section className="py-0 fullscreen">
			<Row className="flex-center min-vh-100 py-6">
				<Col sm={11}
					md={9}
					lg={7}
					xl={6}
					className="col-xxl-5">
					<Card className="text-center">
						<Card.Body className="p-5">
							<div className="display-1 text-300 fs-error">403</div>
							<p className="lead mt-4 text-800 font-sans-serif fw-semi-bold">Acceso denegado...</p>
							<hr/>
							<p>No tienes permiso para acceder a esta página.</p>
							<Link className="btn btn-primary btn-sm mt-3" to="/">
								<FontAwesomeIcon icon={faHome}
									className="me-2"/>
								Regresar
							</Link>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Section>
	);
};

export default Error403;
